export const es = {
  noConversation: {
    welcome: 'Bienvenido a Tu Bandeja de Entrada',
    selectConversation:
      'Selecciona una conversación de la izquierda o haz clic en el botón de abajo para iniciar una nueva.',
    startNew: 'Iniciar Nueva Conversación',
  },
  conversationList: {
    newConversation: 'Nueva Conversación',
    search: 'Buscar',
    conversation: 'conversación',
    conversations: 'conversaciones',
  },
  participantPopover: {
    internal: 'Interno',
    external: 'Externo',
    searchContact: 'Buscar contacto',
    noContactsFound: 'No se encontraron contactos',
  },
  participants: {
    employees: 'Empleados',
    addParticipant: 'Agregar Participante',
    external: 'Externo',
    you: '(tú)',
  },
  conversationCard: {
    untitledConversation: 'Conversación Sin Título',
    loadingParticipants: 'Cargando participantes...',
    noMessagesYet: 'Sin mensajes aún',
  },
};
